import { CreateFocusCss } from '../../../../styles'
import type { Tokens } from '../../../../theming/types'

export default (config: { tokens: Tokens }) => {
  const { tokens } = config
  return {
    wrap: {
      '& a, & button': {
        minWidth: 'inherit',

        ...CreateFocusCss({
          ...tokens.focusOuter,
          outlineColor: '#fff',
        }),
      },
    },
  } as const
}
